import PdfEditorWelcomeIcon from '@/assets/icons/pdf-editor-welcome.svg';
import { Heading, Text } from '@vibe/core';
import React from 'react';

export const WelcomeStepContent: React.FC = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      padding: '8px 0',
    }}
  >
    <img
      src={PdfEditorWelcomeIcon}
      alt="PDF Editor Welcome"
      className="tw-h-20 tw-w-20 tw-text-primary"
    />
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        textAlign: 'center',
      }}
    >
      <Heading type={Heading.types.H3} weight={Text.weights.MEDIUM}>
        Welcome to GetSign PDF editor!
      </Heading>
      <Text
        align="center"
        element="p"
        type={Text.types.TEXT1}
        weight={Text.weights.NORMAL}
        color={Text.colors.SECONDARY}
      >
        Let's walk through GetSign together to help you <br /> create, edit, and get
        your documents ready for signing.<br />
      </Text>
    </div>
  </div>
);

export default WelcomeStepContent;
